import React  from "react";
import { connect } from "react-redux";
import MyDocuments from "./components/MyDocuments";

const documents = [
  {
    title: "Employment Contract",
    date: "January 15, 2026",
  },
  {
    title: "Employee Handbook",
    date: "March 2, 2026",
  },
  {
    title: "Company Policies",
    date: "April 10, 2026",
  },
];

const EmployeeDocuments = () => {
  return (
    <MyDocuments documents={documents} />
  );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeDocuments);